export default Object.freeze({
  fullname: {
    label: "Teljes név",
    help: "Előnév, Családnév és Utónév szóközzel elválasztva.",
    error: "Kérjük, írd be a teljes neved."
  },
  policynumber: {
    label: "Biztosítás kötvényszáma",
    help: "Az UNION biztosításod kötvényszáma 8 számjegyből áll.",
    error:
      "Kérjük, írj be egy érvényes Union biztosítási kötvényszámot. A kötvényszám 7 számjegyű és 6-os számmal kezdődik."
  },
  // contractdate: {
  //   label: "Biztosításkötés dátuma",
  //   help:
  //     "A szerződés kötés dátuma, amelynek bele kell esni a nyereményjáték időtartamába.",
  //   error: "Kérjük, figyelj az alábbi formátumra: ééééhhnn."
  // },
  phone: {
    label: "Mobiltelefonszám",
    help:
      "Érvényes magyarországi mobiltelefon szám, melyen értesíthetünk a nyereményről.",
    error: "Kérjük, írj be egy érvényes magyarországi mobilszámot."
  },
  email: {
    label: "Email cím",
    help:
      "Érvényes email cím, melyen értesítést tudunk küldeni a nyereményről.",
    error: "Kérjük, írj be egy érvényes email címet."
  },
  legal: {
    label: "Elfogadom a nyereményjáték feltételeit",
    help:
      "Önkéntesen hozzájárulok ahhoz, hogy a regisztráció során megadott személyes adataimat az UNION Biztosító a nyereményjáték lebonyolítása céljából kezelje.",
    error: "Kérjük, fogadd el a nyereményjáték feltételeit."
  },
  send: {
    // label: "Adatok küldése"
    label: "elküldöm"
  },
  sweepstakes: {
    model: {
      startdate: new Date(0).getUTCMilliseconds(),
      enddate: new Date(0).getUTCMilliseconds(),
      title: "",
      description: "",
      label: "",
      help: ""
      // imgurl: "",
      // imgalt: ""
    },
    // "csussz-ra-a-nyeremenyre": {
    //   startdate: new Date(0).setUTCFullYear(2020, 0, 10),
    //   enddate: new Date(0).setUTCFullYear(2020, 2, 11), //this should be the set the day after last day
    //   title: "Csússz rá a nyereményre!",
    //   description:
    //     "2020. január 10. és március 10. között a Hóbarát utasbiztosítást kötő személyek között két alkalommal kisorsolunk egy 150 000 Ft-os vásárlási utalványt.",
    //   label: "Elfogadom a nyereményjáték feltételeit",
    //   help:
    //     'A <a href="https://union.hu/letoltheto/utasbiztositas/jatekszabalyzat-vasarlasi-utalvany" target="_blank">Csússz rá a nyereményre! nyereményjáték Játékszabályzatát</a> elolvastam és annak az adatkezelésre vonatkozó rendelkezéseit megértettem és elfogadom, önkéntesen hozzájárulok ahhoz, hogy a regisztráció során megadott személyes adataimat az UNION Biztosító a nyereményjáték lebonyolítása céljából kezelje.'
    // },
    // "tel-vagy-nyar": {
    //   startdate: new Date(0).setUTCFullYear(2024, 11, 1), //start: pl. jun.1. >>> 2023,5,1) hónapnál(-1) >>> 5=június //TESZT MIATT KORÁBBI
    //   enddate: new Date(0).setUTCFullYear(2025, 2, 18), //end: aug. 31 --> sept 1 - this should be the set the day after last day (sept.1 >>> 2024,8,1)
    //   title: "Tél vagy nyár Regisztráció",
    //   description:
    //     "Adataid megadásával most megnyerheted a három darab, egyenként 100 000 Ft értékű Decathlon vásárlási utalvány egyikét!<br/><br/>Azon szerződőink között, akik 2024. december 16. és 2025. március 16. között kötnek <b>Világjáró Horizont Prémium, Világjáró Horizont Prémium útlemondás védelem, HóBarát Fekete</b> vagy <b>HóBarát Fekete útlemondás védelemmel</b> biztosítást és ezen a felületen regisztrálva nyilatkoznak a játékban való részvételükről, a játék végén kisorsolunk három darab 100 000 Ft értékű Decathlon vásárlási utalványt. <br/>Tél vagy nyár? Itt bizony nyeremény is megeshet, hogy vár!",
    //   label: "Elfogadom a nyereményjáték feltételeit",
    //   help:
    //     'A <a href="https://union.hu/letoltheto/jatekszabalyzat/tel-vagy-nyar" target="jatekszabaly" style="color:red;">Játékszabályzat</a> szerinti részvételi feltételeket megismertem és elfogadom. A Személyes adataim megadását megelőzően megismertem a Játékszabályzatban foglalt adatkezelési tájékoztatás tartalmát és annak alapján önkéntesen hozzájárulok ahhoz, hogy a részvétel során megadott személyes adataimat az UNION Vienna Insurance Group Biztosító Zrt. a Játékszabályzat adatkezelésére vonatkozó rendelkezéseiben meghatározottak szerint a nyereményjáték lebonyolítása céljából kezelje.'
    // },
    "var-a-nyar": {
      startdate: new Date(0).setUTCFullYear(2025, 4, 6), //június 1. > teszt miatt május 6. = (2025,4,6)
      enddate: new Date(0).setUTCFullYear(2025, 8, 2), //szeptember 1-jén még elérhtő legyen
      title: "Vár a nyár, vár az új teló! Regisztráció",
      description:
        "Adataid megadásával most megnyerheted a három darab vadiúj, 128 GB-os iPhone 16 Pro egyikét!<br/><br/>Azon szerződőink között, akik 2025. június 1. és 2025. augusztus 31. között kötnek <b>Világjáró Horizont Prémium</b>, <b>Világjáró Horizont Prémium és útlemondás védelem</b> vagy <b>Világjáró Útitárs Horizont Prémium kombinált utas- és sztornóbiztosítást</b> és ezen a felületen regisztrálva nyilatkoznak a játékban való részvételükről, a játék végén kisorsolunk három darab iPhone 16 Pro-t. <br/>Vár a nyár, de megeshet, hogy az új álomtelód is!",
      label: "elfogadom a nyereményjáték feltételeit",
      help:
        'A <a href="https://union.hu/letoltheto/jatekszabalyzat/var-a-nyar" target="jatekszabaly" style="color:red;">Játékszabályzat</a> szerinti részvételi feltételeket megismertem és elfogadom. A Személyes adataim megadását megelőzően megismertem a Játékszabályzatban foglalt adatkezelési tájékoztatás tartalmát és annak alapján önkéntesen hozzájárulok ahhoz, hogy a részvétel során megadott személyes adataimat az UNION Vienna Insurance Group Biztosító Zrt. a Játékszabályzat adatkezelésére vonatkozó rendelkezéseiben meghatározottak szerint a nyereményjáték lebonyolítása céljából kezelje.'
    }
  }
});
